// extracted by mini-css-extract-plugin
export default {"titleRow":"wHkZnALumyHrTxaFKI5G"};